import type { ReactNode } from 'react';

export const symbol_tilt_arrow_down: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h520q24 0 42 18t18 42v600q0 24-18 42t-42 18H220Zm0-60h520v-600H220v600Zm230-233-53-53q-9-9-21.1-9-12.1 0-20.9 9-9 9-9 21t9 21l104 104q9 9 21 9t21-9l104-104q9-9 9-21.16t-8.61-21Q596-475 583.9-475q-12.1 0-20.9 9l-53 53v-197q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v197Zm290 233H220h520Z"
		/>
	</svg>
);
